import { useCallback, useEffect, useState } from 'react';
import PREDEFINED_INTERVALS from '../../../shared/constants/predefinedIntervals';
import isValidDate from '../../../shared/utils/isValidDate';
import getTimeRangeByInterval from '../../../shared/utils/timezoneDateUtils';

export const useVehicleHistoryDates = (timeZone, getTrackPointsResourceParams, triggerId) => {
  const [dateStart, setDateStart] = useState();
  const [dateFinish, setDateFinish] = useState();
  const [intervalOption, setIntervalOption] = useState(PREDEFINED_INTERVALS.TODAY);

  const getCustomHistory = useCallback(() => {
    if (isValidDate(dateStart) && isValidDate(dateFinish)) {
      getTrackPointsResourceParams({
        params: {
          'date.greaterThanOrEqual': dateStart.toISOString(),
          'date.lessThan': dateFinish.toISOString(),
        },
      });
    }
  }, [dateStart, dateFinish, getTrackPointsResourceParams]);

  // Сброс дат при изменении интервала (если не CUSTOM)
  useEffect(() => {
    if (intervalOption !== PREDEFINED_INTERVALS.CUSTOM) {
      setDateStart(null);
      setDateFinish(null);
    }
  }, [triggerId, intervalOption]);

  // Обработка изменения интервала
  useEffect(() => {
    if (!timeZone) return;

    if (intervalOption === PREDEFINED_INTERVALS.CUSTOM) {
      getCustomHistory();
      return;
    }

    const { dateStart: start, dateFinish: finish } = getTimeRangeByInterval(intervalOption, timeZone);
    if (!start || !finish) return;

    getTrackPointsResourceParams({
      params: {
        'date.greaterThanOrEqual': start.toISOString(),
        'date.lessThan': finish.toISOString(),
      },
    });

    setDateStart(start);
    setDateFinish(finish);
  }, [intervalOption, triggerId, timeZone, getTrackPointsResourceParams]);

  return {
    dateStart,
    setDateStart,
    dateFinish,
    setDateFinish,
    intervalOption,
    setIntervalOption,
    getCustomHistory,
  };
};

export default useVehicleHistoryDates;
